import React, { useContext, useState } from 'react';
import { ModuleAccessContext } from '../../context/moduleaccessContext';

const ModuleAccess = () => {
  const { modules, loading } = useContext(ModuleAccessContext);
  const [search, setSearch] = useState('');

  const filteredModules = modules.filter(
    m =>
      m.moduleName?.toLowerCase().includes(search.toLowerCase()) ||
      String(m.moduleNo).includes(search)
  );

  return (
    <div style={{ padding: 32 }}>
      <h2>Module Access</h2>
      <div style={{ display: 'flex', gap: 32, marginBottom: 16 }}>
        <div>
          <label>Co Code</label>
          <input style={{ width: 200 }} />
        </div>
        <div>
          <label>Co Name</label>
          <input style={{ width: 200 }} />
        </div>
      </div>
      <div style={{ background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #0001', padding: 24, maxWidth: 800 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
          <input
            placeholder="🔍 Search"
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ flex: 1, marginRight: 16, padding: 8, borderRadius: 6, border: '1px solid #D5D5D5' }}
          />
          <button className="btn btn-info" style={{ marginRight: 8 }}>Report</button>
          <button className="btn btn-outline-info">Export</button>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#d3e6ea' }}>
              <th style={{ padding: 8, textAlign: 'left' }}>Module No</th>
              <th style={{ padding: 8, textAlign: 'left' }}>Module Name</th>
              <th style={{ padding: 8, textAlign: 'left' }}>Active</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={3}>Loading...</td></tr>
            ) : filteredModules.length === 0 ? (
              <tr><td colSpan={3}>No modules found.</td></tr>
            ) : (
              filteredModules.map(m => (
                <tr key={m.moduleNo}>
                  <td style={{ padding: 8 }}>{m.moduleNo}</td>
                  <td style={{ padding: 8 }}>{m.moduleName}</td>
                  <td style={{ padding: 8 }}>
                    <input type="checkbox" checked={!!m.active} readOnly />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ModuleAccess;